import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Input, Button, Avatar, Typography, Row, Col, Upload, Modal, message } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import useFetchApiData from "../helper/useFetchApiData";
import axios from "axios";

const { Title, Text } = Typography;

const ProfileSection = () => {
  const data = useFetchApiData("/customer/info");
  const [editMode, setEditMode] = useState(false);

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleFormSubmit = (values) => {
    console.warn(values);
    console.warn(localStorage.getItem("accessToken"));
    axios
      .put(process.env.REACT_APP_BACKEND_URI + "/customer/update-profile", values, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      })
      .then((response) => {
        message.success("Profile updated successfully");
        setEditMode(false);
      })
      .catch((error) => {
        message.error("Something Went Wrong");
      });
  };

  const confirmSaveChanges = (values, submitForm) => {
    Modal.confirm({
      title: "Are you sure you want to save changes?",
      content: "This action will update your profile information.",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        submitForm(); // Trigger Formik's submit function
      },
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          backgroundColor: "#6C1C95",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <Avatar
          size={100}
          style={{
            backgroundColor: "#e6e6e6",
            marginBottom: "10px",
          }}
          icon={<CameraOutlined />}
        />
        <Upload>
          <Button type="link" icon={<CameraOutlined />} />
        </Upload>
        <Title level={3} style={{ color: "#fff", margin: 0 }}>
          {data.f_name} {data.l_name}
        </Title>
        <Text style={{ color: "#fff" }}>{data.email}</Text>
      </div>

      <Formik
        enableReinitialize
        initialValues={{
          f_name: data.f_name || "",
          l_name: data.l_name || "",
          email: data.email || "",
          phone: data.phone || "",
        }}
        onSubmit={handleFormSubmit}
      >
        {({ values, submitForm }) => (
          <Form>
            <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
              <Col span={12}>
                <Text>First Name</Text>
                <Field name="f_name">
                  {({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      readOnly={!editMode}
                      onClick={editMode ? undefined : handleEditClick}
                    />
                  )}
                </Field>
              </Col>
              <Col span={12}>
                <Text>Last Name</Text>
                <Field name="l_name">
                  {({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      readOnly={!editMode}
                      onClick={editMode ? undefined : handleEditClick}
                    />
                  )}
                </Field>
              </Col>
              <Col span={12}>
                <Text>Email</Text>
                <Field name="email">
                  {({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      readOnly={!editMode}
                      onClick={editMode ? undefined : handleEditClick}
                    />
                  )}
                </Field>
              </Col>
              <Col span={12}>
                <Text>Mobile Number</Text>
                <Field name="phone">
                  {({ field }) => (
                    <Input
                      size="large"
                      {...field}
                      readOnly={!editMode}
                      onClick={editMode ? undefined : handleEditClick}
                    />
                  )}
                </Field>
              </Col>
            </Row>
            <div style={{ marginTop: "20px" }}>
              <Button
                type="primary"
                onClick={() => confirmSaveChanges(values, submitForm)}
              >
                Save Changes
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ProfileSection;
